/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Ask_RecommendedInputs */

const en_us2_coach_extra_ask_recommended = /** @type {(inputs: Coach_Extra_Ask_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

const pt_br2_coach_extra_ask_recommended = /** @type {(inputs: Coach_Extra_Ask_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

const es_419_coach_extra_ask_recommended = /** @type {(inputs: Coach_Extra_Ask_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

const pt_pt2_coach_extra_ask_recommended = /** @type {(inputs: Coach_Extra_Ask_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

const fr_fr2_coach_extra_ask_recommended = /** @type {(inputs: Coach_Extra_Ask_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommandé`)
};

const de_de2_coach_extra_ask_recommended = /** @type {(inputs: Coach_Extra_Ask_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfohlen`)
};

const it_it2_coach_extra_ask_recommended = /** @type {(inputs: Coach_Extra_Ask_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consigliato`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Coach_Extra_Ask_RecommendedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_ask_recommended = /** @type {((inputs?: Coach_Extra_Ask_RecommendedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Ask_RecommendedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_ask_recommended(inputs)
	if (locale === "es-419") return es_419_coach_extra_ask_recommended(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_ask_recommended(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_ask_recommended(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_ask_recommended(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_ask_recommended(inputs)
	return en_us2_coach_extra_ask_recommended(inputs)
});
export { coach_extra_ask_recommended as "coach-extra.ask_recommended" }